export default __webpack_public_path__ + "static/media/diagram-ko-desktop.24f05f98.jpg";